import toast from 'react-hot-toast';

/**
 * notify: thin wrapper over react-hot-toast so every screen uses the same
 * durations and wording. Prefer these over bespoke Notification components.
 */
export const notify = {
  success: (message, opts) => toast.success(message, { duration: 3000, ...opts }),
  error: (message, opts) => toast.error(message, { duration: 4500, ...opts }),
  info: (message, opts) => toast(message, { duration: 3000, icon: 'ℹ️', ...opts }),
  loading: (message, opts) => toast.loading(message, opts),
  dismiss: (id) => toast.dismiss(id),
  promise: (promise, messages, opts) => toast.promise(promise, messages, opts),
  /** Update an existing loading toast to a result. */
  resolve: (id, message) => toast.success(message, { id }),
  reject: (id, message) => toast.error(message, { id }),
};

/** Copies text to the clipboard and shows a toast. Returns a promise. */
export async function copyToClipboard(text, message = 'Copied to clipboard') {
  try {
    await navigator.clipboard.writeText(String(text ?? ''));
    if (message) notify.success(message);
    return true;
  } catch (error) {
    notify.error('Could not copy to clipboard');
    return false;
  }
}

/** Extracts a human message from an axios/firebase error. */
export function errorMessage(error, fallback = 'Something went wrong') {
  const data = error?.response?.data;
  if (typeof data === 'string' && data.trim()) return data;
  if (data?.message) return data.message;
  if (data?.error && typeof data.error === 'string') return data.error;
  if (error?.message) return error.message;
  return fallback;
}

export default notify;
